import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const DebtCredt1 = () => {
    const dates = [
        "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20", 
        "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21", 
        "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22", 
        "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23", 
        "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
    ];

    const accountsReceivable = [
        11999.91, 7178.79, 11988.81, 13937.39, 17391.97, 18981.15, 22798.45, 19977.51, 17325.36, 12485.90, 15105.12, 16481.88, 
        18379.90, 16338.45, 18311.19, 19518.05, 18902.28, 26229.64, 27283.16, 30075.33, 28284.60, 30127.37, 32637.13, 30628.41, 
        33592.46, 36717.20, 30112.24, 31731.62, 29584.16, 51272.42, 33812.47, 31448.81, 30900.88, 33035.02, 34131.11, 34577.06, 
        34340.45, 35148.10, 36162.02, 36559.70, 37117.38, 36965.69, 35808.08, 92323.91, 43400.81, 37120.85, 38072.72, 41159.32, 
        40843.94, 39641.82, 40705.49, 40203.63, 41181.77, 42320.97, 45087.42, 44684.44, 49704.15, 48247.18, 54456.59, 87111.19
    ];

    const accountsPayable = [
        118391.1, 105264.9, 102881.4, 94515.3, 128838.5, 120780.1, 90177.6, 92006.6, 97970.1, 80613.7, 105951.6, 105955.8, 
        130530.2, 158975.6, 183098.5, 184515.2, 187053.4, 179124.8, 201422.2, 193481.1, 205462.9, 205350.8, 221278.0, 213281.1, 
        218876.9, 207688.6, 208177.7, 199999.4, 228501.9, 232553.6, 213317.8, 243829.9, 245824.7, 237401.3, 229782.1, 220846.3, 
        215273.3, 218537.3, 217053.6, 213012.8, 222428.2, 221268.9, 221346.9, 233955.1, 250556.0, 260182.1, 255281.5, 247383.4, 
        252959.7, 270042.5, 277534.8, 281712.1, 289491.3, 279507.0, 266353.7, 269980.0, 266769.1, 252953.7, 248312.3, 249658.8
    ];

  // Calculate the trend lines for Accounts Receivable and Accounts Payable
  const trendLineReceivable = getLinearTrend(accountsReceivable);
  const trendLinePayable = getLinearTrend(accountsPayable);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Accounts Receivable", "Trend Line (Receivable)", "Accounts Payable", "Trend Line (Payable)"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value} $",
      },
    },
    series: [
      {
        name: "Accounts Receivable",
        type: "line",
        data: accountsReceivable,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line (Receivable)",
        type: "line",
        data: trendLineReceivable,
        smooth: true,
        lineStyle: { type: "dashed", color: "blue" },
      },
      {
        name: "Accounts Payable",
        type: "line",
        data: accountsPayable,
        smooth: true,
        lineStyle: { color: "green" },
      },
      {
        name: "Trend Line (Payable)",
        type: "line",
        data: trendLinePayable,
        smooth: true,
        lineStyle: { type: "dashed", color: "green" },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default DebtCredt1;
